// extracted by mini-css-extract-plugin
module.exports = {"MarkdownContentWrapper":"ApiGuidePage_MarkdownContentWrapper__UDwYF"};